var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.497 13c.829 0 1.5.672 1.5 1.5v6c0 .828-.671 1.5-1.5 1.5h-6c-.828 0-1.5-.672-1.5-1.5v-6c0-.828.672-1.5 1.5-1.5h6zM9.5 13c.828 0 1.5.672 1.5 1.5v6c0 .828-.672 1.5-1.5 1.5h-6c-.828 0-1.5-.672-1.5-1.5v-6c0-.828.672-1.5 1.5-1.5h6zm10.797 1.7h-5.6v5.6h5.6v-5.6zM9.3 14.7H3.7v5.6h5.6v-5.6zM9.5 2c.828 0 1.5.672 1.5 1.5v6c0 .828-.672 1.5-1.5 1.5h-6C2.672 11 2 10.328 2 9.5v-6C2 2.672 2.672 2 3.5 2h6zm10.997 0c.829 0 1.5.672 1.5 1.5v6c0 .828-.671 1.5-1.5 1.5h-6c-.828 0-1.5-.672-1.5-1.5v-6c0-.828.672-1.5 1.5-1.5h6zM9.3 3.7H3.7v5.6h5.6V3.7zm10.997 0h-5.6v5.6h5.6V3.7z",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarProducts);
export default __webpack_public_path__ + "static/media/navbar-products.8f09d4231beecb6b0a9a6b677f951423.svg";
export { ForwardRef as ReactComponent };